import React from 'react';
import { PlacementType, } from '../tenant';
export const isPlacement = (object) => {
    const placement = object;
    return !!placement.id
        && placement.type !== undefined
        && Object.values(PlacementType).includes(placement.type);
};
export const isScreen = (placement) => (placement.uri !== undefined
    && (placement.type === PlacementType.SectionScreen
        || placement.type === PlacementType.SubpageScreen
        || placement.type === PlacementType.SubsectionScreen
        || placement.type === PlacementType.FullScreenSheet
        || placement.type === PlacementType.BottomSheet
        || placement.type === PlacementType.MaximizedScreen));
export const tenantScreens = (props) => props
    .placements.filter(isScreen).map((placement) => {
    const ScreenComponent = placement.component;
    return {
        component: ScreenComponent
            ? () => (React.createElement(ScreenComponent
            // Passing all props to reduce maintenance effort
            // eslint-disable-next-line react/jsx-props-no-spreading
            , Object.assign({}, props)))
            : undefined,
        id: placement.id,
        type: placement.type,
    };
});
export const findScreenByUri = (placements, uri) => placements
    .filter(isScreen)
    .find((placement) => new RegExp(placement.uri).test(uri));
export const findHomeSectionPlacement = (placements) => {
    const homeSections = placements
        .filter((pl) => pl.type === PlacementType.SectionScreen)
        .sort((pl1, pl2) => pl1.primaryNav.priority
        - pl2.primaryNav.priority);
    return homeSections && homeSections[0];
};
function isSectionScreenPlacement(p) {
    return p.type === PlacementType.SectionScreen;
}
export const findPrimaryNavByUri = (placements, uri) => {
    var _a;
    const placement = findScreenByUri(placements, uri) || placements
        .filter(isSectionScreenPlacement)
        .find((p) => new RegExp(p.primaryNav.uri).test(uri));
    return (_a = placement === null || placement === void 0 ? void 0 : placement.primaryNav) === null || _a === void 0 ? void 0 : _a.id;
};
export const findDeepLinkSectionByUri = (placements, uri) => {
    const placement = findScreenByUri(placements, uri);
    if (placement) {
        switch (placement.type) {
            case PlacementType.SectionScreen: {
                return placement;
            }
            case PlacementType.SubpageScreen: {
                const sectionPlacement = placements
                    .filter((pl) => pl.type === PlacementType.SectionScreen)
                    .find((pl) => pl.id === placement.deepLinkId);
                return sectionPlacement ? sectionPlacement
                    : findHomeSectionPlacement(placements);
            }
            default:
                return findHomeSectionPlacement(placements);
        }
    }
    return findHomeSectionPlacement(placements);
};
export const findPrimaryNavByDeepLinkUri = (placements, uri) => { var _a, _b; return (_b = (_a = findDeepLinkSectionByUri(placements, uri)) === null || _a === void 0 ? void 0 : _a.primaryNav) === null || _b === void 0 ? void 0 : _b.id; };
export const findScreen = (placements, screenName) => placements
    .filter(isScreen)
    .find((placement) => placement.id === screenName);
export const findScreenName = (placements, uri) => {
    const screenPlacement = findScreenByUri(placements, uri);
    if (screenPlacement)
        return screenPlacement.id;
    return undefined;
};
export const findTabs = (placements) => placements
    .filter(isSectionScreenPlacement)
    .sort((t1, t2) => t1.primaryNav.priority - t2.primaryNav.priority);
export const getSubsectionPlacementsForSectionUri = (placements, currentUri) => {
    const sectionScreenPlacement = findTabs(placements)
        .find((p) => p.uri === currentUri);
    if (sectionScreenPlacement) {
        const allSubsectionsForSection = placements
            .filter((p) => p.type === PlacementType.SubsectionScreen)
            .filter((p) => p.sectionId
            === sectionScreenPlacement.id);
        if (allSubsectionsForSection
            && allSubsectionsForSection.length > 0
            && sectionScreenPlacement.subsectionPriorityFunc) {
            const priorityIds = sectionScreenPlacement.subsectionPriorityFunc();
            // returns subsections ordered according to the subsectionPriorityFunc
            const subsectionPlacements = priorityIds
                .map((id) => allSubsectionsForSection.find((subsection) => subsection.id === id))
                .filter((placement) => placement !== undefined);
            return subsectionPlacements;
        }
    }
    return undefined;
};
//# sourceMappingURL=screens.js.map